import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from '../hooks/useTranslation';
import { Clock, Plus, ArrowRight } from 'lucide-react';

const EngagementsWidget = () => {
  const navigate = useNavigate();
  const { api } = useAuth();
  const { t } = useTranslation();
  const [engs, setEngs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get('/api/engagements/today');
        setEngs(res.data.engagements || []);
      } catch { /* silent */ }
      finally { setLoading(false); }
    };
    fetch();
  }, [api]);

  if (loading) return null;

  return (
    <div data-testid="engagements-widget" className="glass-card p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-white font-semibold text-sm flex items-center gap-2">
          <Clock className="w-4 h-4 text-atlasCyan" />
          {t('engagements.todayWidget')}
        </h3>
        <button onClick={() => navigate('/engagements')} className="text-xs text-atlasCyan hover:text-atlasCyan/80 transition-colors flex items-center gap-1">
          {t('engagements.viewAll')} <ArrowRight className="w-3 h-3" />
        </button>
      </div>
      {engs.length === 0 ? (
        <div className="flex items-center justify-between">
          <p className="text-sm text-atlasTextSecondary">{t('engagements.noneToday')}</p>
          <button onClick={() => navigate('/engagements')} className="text-xs text-atlasCyan hover:underline flex items-center gap-1">
            <Plus className="w-3 h-3" /> {t('engagements.createOne')}
          </button>
        </div>
      ) : (
        <div className="space-y-2">
          {engs.map(e => (
            <button key={e.id} onClick={() => navigate('/engagements')} data-testid={`eng-widget-${e.id}`}
              className="w-full text-left flex items-center gap-3 p-2.5 rounded-lg bg-white/[0.02] hover:bg-white/[0.04] transition-colors">
              <span className="text-xs text-atlasCyan font-mono whitespace-nowrap">{e.heure_debut}</span>
              <span className="text-sm text-white truncate">{e.description}</span>
              {e.statut === 'en_cours' && <span className="w-2 h-2 bg-atlasCyan rounded-full animate-pulse flex-shrink-0" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EngagementsWidget;
